import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-numbers-cell',
  templateUrl: './numbers-cell.component.html',
  styleUrls: ['./numbers-cell.component.scss'],
  standalone: false
})
export class NumbersCellComponent {

  @Input() orderNumber: string;
  @Input() transactionNumber: string;

}
